import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	UntypedFormArray,
	UntypedFormControl,
	UntypedFormGroup,
} from '@angular/forms';
import { ConfigQuestion } from '../../models/config-question.interface';
import { ErrorMessage } from '../../constants/enum.const';
import { ConfigUtil } from '../../utils/config.util';

@Component({
	selector: 'bcb-website-url-list-input',
	templateUrl: './website-url-list-input.component.html',
	styleUrls: ['./website-url-list-input.component.scss'],
})
export class WebsiteUrlListInputComponent implements OnInit {
	@Input() question!: ConfigQuestion;
	@Input() formGroup!: UntypedFormGroup;
	@Input() errorMessage?: ErrorMessage;
	@Input() questionsConfig!: ConfigUtil;

	@Output() urlsChange = new EventEmitter<string[]>();

	get rows(): UntypedFormArray {
		return this.formGroup.get(this.question.key) as UntypedFormArray;
	}

	ngOnInit(): void {
		if (!this.rows?.length) {
			this.addRow();
		}
	}

	addRow(): void {
		if (this.rows.disabled) {
			return;
		}
		this.rows.push(
			this.questionsConfig.createUrlListControl(this.question)
		);
		this.emitChange();
	}

	removeRow(index: number): void {
		if (this.rows.disabled) {
			return;
		}
		if (this.rows.length <= 1) {
			this.rows.at(0).setValue('');
			this.emitChange();
			return;
		}
		this.rows.removeAt(index);
		this.emitChange();
	}

	rowError(index: number): ErrorMessage | undefined {
		const row = this.rows.at(index) as UntypedFormControl;
		if (!row?.touched || !row.errors) {
			return undefined;
		}
		const override =
			this.question.validators?.errorMessages?.pattern ??
			this.errorMessage;
		return row.errors['pattern'] ? override : this.errorMessage;
	}

	onRowBlur(index: number): void {
		this.rows.at(index).markAsTouched();
		this.emitChange();
	}

	private emitChange(): void {
		this.urlsChange.emit(
			this.rows.value.map((value: unknown) =>
				typeof value === 'string' ? value : ''
			)
		);
	}
}
